import DateService, { simulationFormat } from '@services/DateService'
import type { Simulation } from '../../Simulation'
import { TYPE_GEOMETRY } from '@enums/TypeGeometry'
import { Minutes } from 'src/typings/time'
import { MeteoConditionsSendDTO } from './MeteoConditionsSendDTO'
import { FuelModelHumidityDTO } from './FuelModelHumidityDTO'
import { FuelModelLoadDTO } from './FuelModelLoadDTO'
import { CrownFireType } from '@enums/CrownFireType'

export interface SimulationSendDTO {
  name: string
  observation: string
  geometry?: number[][][]
  typeGeometry: TYPE_GEOMETRY[]
  dateInit?: string
  dateEnd?: string
  timeStep: Minutes
  useWindNinja: number
  windNinjaResolution?: number
  firewall: any[] | null | undefined
  typeFirewall: TYPE_GEOMETRY[]
  useFirewall: number
  useCustomMeteo: 1 | 0
  meteoData: MeteoConditionsSendDTO[]
  fuelModel: any
  fuelModelArea: any
  municipality?: string
  simulationCenter: JSONValue
  fuelModelDefinition?: FuelModelHumidityDTO[]
  fuelModelLoads: FuelModelLoadDTO[]
  crownFlag: number
  foliarMoisture: number
  crownFireFinney: CrownFireType
}

export namespace SimulationSendDTO {
  export function fromSimulation(simulation: Simulation): SimulationSendDTO {
    return {
      name: simulation.simulationListItem.name,
      observation: simulation.observations,
      geometry: simulation.simulationGeometries,
      typeGeometry: simulation.typeGeometries,
      dateInit: simulation.simulationListItem.initDate
        .utc()
        .format(simulationFormat),
      dateEnd: DateService.formatDate(simulation.endDate, simulationFormat),
      timeStep: simulation.timeInterval,
      useWindNinja: Number(simulation.isLocalWindActive),
      windNinjaResolution: simulation.localWindResolution,
      firewall: simulation.firewalls,
      typeFirewall: simulation.firewallType,
      useFirewall: Number(simulation.useFirewall),
      meteoData: simulation.meteoConditions.map((meteo) =>
        MeteoConditionsSendDTO.fromMeteoConditionsDTO(meteo)
      ),
      useCustomMeteo: simulation.isCustomMeteo ? 1 : 0,
      fuelModel: simulation.fuelModels,
      fuelModelArea: simulation.fuelModelAreas,
      municipality: simulation.municipality,
      simulationCenter: simulation.simulationCenter?.toJSON(),
      fuelModelDefinition: simulation.fuelModelHumidity,
      fuelModelLoads: simulation.fuelModelLoads,
      crownFlag: Number(simulation.crownFlag),
      foliarMoisture: simulation.foliarMoisture,
      crownFireFinney: simulation.crownFireMethod
    }
  }
}
